import utils from 'utils';
let channel = 'api/v2';

if (utils.isMobile.Hw()) {
  channel = 'fapi/v1';
}

let config = {
  channel: channel
};
let envConfig;

switch (API_ENV) {
  case 'production':
    envConfig = require('./production');
    break;
  case 'rc':
    envConfig = require('./rc');
    break;
  case 'qa':
    envConfig = require('./qa');
    break;
  default:
    envConfig = require('./rc');
    break;
}

config = { ...envConfig, config };

export default config;
